/**
 * iter163h — Floating DM button + modal.
 *
 * Bottom-right pill with unread count. Clicking opens the dark DM modal.
 * Hidden entirely for roles that can't use DMs (Company / Company Rep).
 */
import { MessageCircle } from 'lucide-react';
import { useDM } from '../../contexts/DMContext';
import DMModal from './DMModal';

export default function FloatingDMButton() {
  const { eligible, unread, open, setOpen } = useDM();
  if (!eligible) return null;

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label="Open private messages"
        data-testid="dm-floating-button"
        className="fixed bottom-6 right-6 z-40 flex items-center gap-2 rounded-full bg-slate-900 px-4 py-3 text-white shadow-lg shadow-slate-900/30 ring-1 ring-white/10 transition-all hover:scale-[1.03] hover:bg-slate-800 active:scale-95"
      >
        <MessageCircle size={18} />
        <span className="text-sm font-medium hidden sm:inline">Messages</span>
        {unread > 0 && (
          <span
            data-testid="dm-floating-unread"
            className="ml-1 inline-flex h-5 min-w-[20px] items-center justify-center rounded-full bg-rose-500 px-1.5 text-[11px] font-semibold leading-none"
          >
            {unread > 9 ? '9+' : unread}
          </span>
        )}
      </button>
      {open && <DMModal />}
    </>
  );
}
